import { useMutation } from '@tanstack/react-query';
import { httpClientPostJson } from '../httpClient';

interface IfInsuranceAddOn {
  title: string;
  name: string;
  description: string;
  monthlyPrice: number;
  exclude: string[];
}

interface IfInsuranceItems {
  name: string;
  description: string;
}

export interface IfInsurance {
  name: string;
  price: number;
  unit: string;
  includesFinancingInPrice: boolean;
  description: string;
  addOns: IfInsuranceAddOn[];
  insuranceItems: IfInsuranceItems[];
  branding: string;
  legalUrl: string;
  legalDescription: string;
}

interface InsuranceBySsnResponse {
  successful: true;
  response: {
    insurances: IfInsurance[]; // Updated to use IfInsurance interface
  };
}
interface UseIfInsuranceBySsnVariables {
  branchId: string;
  drivingDistance: string;
  socialId: string;
  vehicleId: string;
}

const useIfInsuranceBySsn = () => {
  const mutation = useMutation<InsuranceBySsnResponse, Error, UseIfInsuranceBySsnVariables>({
    mutationFn: (variables) =>
      httpClientPostJson<InsuranceBySsnResponse>(
        `${process.env.NEXT_PUBLIC_ECOM_URL}/insurance/inquiry`,
        variables,
      ),
  });

  return mutation;
};

export default useIfInsuranceBySsn;
